import React from 'react';
import { useSelector } from 'react-redux';
import ItemBlock from '../../itemBlock/ItemBlock';
import classes from './ToolboxBlock.module.css';

const ToolboxBlock = ({ title, description, materials }) => {
  const { texts, lang } = useSelector(state => state.translate);

  return (
    <ItemBlock title={texts[title] || title}>
      <div className={classes.wrapper} id="tools-box-block">
        {description && (
          <p className={classes.description}>
            {texts[description] || description}
          </p>
        )}
        {materials && materials.length > 0 && (
          <div className={classes.materialsList}>
            {materials.map((material, index) => (
              <div className={classes.linkBox}>
                <a
                  key={index}
                  href={material.link?.[lang] || material.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.materialLink}
                >
                  {texts[material.text] || material.text}
                </a>
              </div>
            ))}
          </div>
        )}
      </div>
    </ItemBlock>
  );
};

export default ToolboxBlock;

